import { RootState } from "common/reducers";
import { MapOf } from "immutable";
import { createSelector } from "reselect";

/**
 * Returns a temporary form by it's name
 *
 * @param {any} state
 * @param {string} name
 * @returns {Map}
 */
export const form = (state: RootState, { name }: { name: string }) => state.getIn(["rsfForms", "byForm"]).get(name);

/**
 * Retrieves the form errors from the state based on the specified path.
 * @param state - The root state of the application.
 * @param {{ path: <string | number>[]}} options The path to the form errors.
 * @returns The form errors at the specified path.
 */
export const formErrors = (state: RootState, { path }: { path: (string | number)[] }) => {
  const rsfFormErrorsPath = ["rsfForms", "errors"] as (string | number)[];
  return state.getIn(rsfFormErrorsPath.concat(path)) as MapOf<any>;
};

/**
 * Returns if a form has errors.
 * @param state - The root state of the application.
 * @param {{ path: <string | number>[]}} options The path to the form errors.
 * @returns true if the form has errors.
 */
export const hasFormErrors = createSelector([formErrors], (errors) => !!errors && errors.size > 0);
